import {ReportTableColumn, ReportTableConfigInterface, ReportTableData, } from 'appShared/components';
import {MarketDataFeedsServiceUserSelector} from 'appAssets/selectors';
import {ApiError, ApiResponse} from '@spa/api/lib/common';
import {PanelServiceUsersEditResolverDataInterface} from 'appEntries/panel/interfaces';
import {HttpStatusCodesEnum} from '@spa/api';
import {ServiceUsersReportResolverErrorStatesEnum} from 'appEntries/panel/enums';
import {ClientAccessRightsMessages, ServiceUsersMessages} from 'appAssets/messages';
import {InitialComponentDataValidationException} from 'appShared/exceptions';

export const validateInitialServiceUserData = (response: ApiResponse<ApiError[] | PanelServiceUsersEditResolverDataInterface>) => {
    if (response.status === HttpStatusCodesEnum.Ok) {
        return;
    }

    const messages = (response.data as ApiError[]).map((error: ApiError) => {
        switch (error.status) {
            case ServiceUsersReportResolverErrorStatesEnum.GetServiceUserSettingsFailed:
                return ServiceUsersMessages.GetServiceUserSettingsFailed.message;
            case ServiceUsersReportResolverErrorStatesEnum.GetReportFailed:
                return ServiceUsersMessages.GetReportFailed.message;
            default:
                return ClientAccessRightsMessages.UnknownError.message;
        }
    });

    throw new InitialComponentDataValidationException(messages);
};

export const PanelServiceUsersDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Service User',
                selector: MarketDataFeedsServiceUserSelector,
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};

export const ServiceUsersDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: MarketDataFeedsServiceUserSelector,
            value: null,
            hidden: false
        }),
    ];
};
